<template>
    <div>
        <input
            ref="input"
            type="tel"
            class="form-control"
            @focusin="clearErrors"
            v-bind="attrs"
        />
        <small class="text-danger" v-if="invalidPhoneNumber"
            >Telefonnumret är ogiltigt</small
        >
    </div>
</template>

<style lang="css"></style>

<script lang="ts">
export default { inheritAttrs: false };
</script>

<script setup lang="ts">
import "intl-tel-input/build/css/intlTelInput.css";
import { onBeforeUnmount, onMounted, ref, useAttrs, watch } from "vue";

interface Props {
    field?: string;
    modelValue?: string | null;
    countryCode?: string;
    seOnly?: boolean;
    initialCountry?: string;
}

const props = withDefaults(defineProps<Props>(), {
    modelValue: undefined,
    seOnly: true,
    initialCountry: "SE",
});
const emit = defineEmits<{
        (event: "update:modelValue", value: string | null): void;
}>();
const attrs = useAttrs();
const input = ref<HTMLInputElement | null>(null);
const invalidPhoneNumber = ref(false);
let telInput: any = null;

function modelValue(): string | null | undefined {
    return props.modelValue;
}

function clearErrors(): void {
    invalidPhoneNumber.value = false;
}

function emitValue(value: string | null): void {
    emit("update:modelValue", value);
}

function onInput(): void {
    if (!telInput?.isValidNumber()) {
        emitValue(null);
        return;
    }

    emitValue(telInput.getNumber(window.IntlTelInput.utils.numberFormat.E164));
}

onMounted(() => {
    if (!input.value) {
        return;
    }

    telInput = window.IntlTelInput(input.value, {
        initialCountry: props.initialCountry,
        separateDialCode: !props.seOnly,
        allowDropdown: !props.seOnly,
        strictMode: true,
        hiddenInput: (telInputName: string) => ({
            phone: telInputName,
            country: props.countryCode,
        }),
    });

    if (modelValue()) {
        telInput.setNumber(modelValue());
    }
    input.value.addEventListener("input", onInput);
});

watch(modelValue, (value) => {
    if (telInput && value && telInput.getNumber() !== value) {
        telInput.setNumber(value);
    }
});

onBeforeUnmount(() => {
    input.value?.removeEventListener("input", onInput);
    telInput?.destroy?.();
});
</script>
